import { GetServerSideProps } from 'next';
import React from 'react';
import Head from 'next/head';
import { featureTogglesHandler } from '@/utils/shared-handler/feature-toggle-handler';
import { FEATURE_TOGGLE_LIST } from '@/context/feature-toggles/feature-toggles.types';
import { footerHandler } from '../../modules/footer';
import LegalContentPage, {
  getNavItemProperties,
} from '../../modules/legal-content-page/legal-content-page';
import { legalContentPageHandler } from '../../modules/legal-content-page/legal-content-page.handler';
import { LegalContentComponentProperties } from '../../modules/legal-content-page/legal-content-page.types';

export type LegalPageProperties = {
  pageTitle: string;
  legalPageProperties: LegalContentComponentProperties;
};

const LegalPage = ({ pageTitle, legalPageProperties }: LegalPageProperties) => {
  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <LegalContentPage {...legalPageProperties} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps<
  LegalPageProperties
> = async context => {
  const [footerProperties, legalPageProperties] = await Promise.all([
    footerHandler(context),
    legalContentPageHandler(context),
  ]);

  // The following logic is needed to keep /help-centre from being accessible before Channel's club go live
  const featureToggleList = await featureTogglesHandler(context.req.opco);

  const hideHelpCentre = !featureToggleList.includes(
    FEATURE_TOGGLE_LIST.TEMP_SHARED_FOOTER,
  );

  if (legalPageProperties.activeUrl === '/help-centre' && hideHelpCentre)
    return {
      redirect: {
        destination: `/faq`,
        permanent: false,
      },
    };
  const { pageTitle } = context.req.opco;
  const { activeUrl, data: legalPageData } = legalPageProperties;
  const { ctaText: currentPage } = getNavItemProperties(
    activeUrl,
    legalPageData,
  );

  return {
    props: {
      pageTitle: currentPage ? `${currentPage} | ${pageTitle}` : pageTitle,
      legalPageProperties: {
        ...legalPageProperties,
        navigation: footerProperties.navigation,
      },
    },
  };
};

export default LegalPage;
